import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { dateString } from '../utils';
import { setLogStore } from '../logging';
import { selectLog } from './state';

@Injectable({ providedIn: 'root' })
export class DebugService {
    public log$: Observable<string[]> = this.store.select(selectLog);

    constructor(private store: Store) {
        // Register store dispatch with logging.ts so it can dispatch log actions
        setLogStore((action) => this.store.dispatch(action));
    }

    getInstance(prefix: string): Logger {
        return {
            log: (...args: any[]) => {
                // Just use console.log directly - logging.ts will capture it and dispatch to store
                const message = `${prefix || ''} ${dateString(new Date())} ${args
                    .map((x) => {
                        if (typeof x === 'string') {
                            return x;
                        }

                        if (typeof x === 'object') {
                            return JSON.stringify(x, null, 4);
                        }

                        return x?.toString();
                    })
                    .join(', ')}`;
                console.log(message);
            }
        };
    }
}

export interface Logger {
    log: (...args: any[]) => void;
}
